import isEqual from 'lodash/isEqual';
import { Editor, Path, Node, Transforms } from 'slate';

import emptyNode from '@ui/MarkdownEditor/emptyNode';
import type { OnKeyDown } from '@ui/MarkdownEditor/types';

import { isFigure } from '../Figure/shared';

import { isFigcaption } from './shared';

const backspace: OnKeyDown = (event, editor) => {
  if (!(event.key === 'Backspace' && editor.selection)) return;

  const captionEntry = Editor.above(editor, { match: isFigcaption });
  if (!captionEntry) return;
  const [caption, path] = captionEntry;

  if (Node.string(caption) !== '') return;

  event.preventDefault();
  event.stopPropagation();

  const nextEntry = Editor.next(editor, { at: path });

  if (nextEntry && isEqual(nextEntry[0], emptyNode())) {
    Transforms.select(editor, Editor.start(editor, nextEntry[1]));
  } else {
    const [, figurePath] = Editor.above(editor, { match: isFigure }) || [];
    if (figurePath) {
      Transforms.insertNodes(editor, emptyNode(), { at: Path.next(figurePath), select: true });
    } else {
      // eslint-disable-next-line no-console
      console.warn("Couldn't find a figure above a figcaption?!");
      Transforms.insertNodes(editor, emptyNode(), { at: Path.next(path), select: true });
    }
  }
};

const arrowUp: OnKeyDown = (event, editor) => {
  if (!(event.key === 'ArrowUp' && !event.shiftKey && editor.selection)) return;

  const captionEntry = Editor.above(editor, { match: isFigcaption });
  // const rootPath = editor.selection.anchor.path.slice(0, 1);

  if (!captionEntry) return;
  const [, path] = captionEntry;

  // If we are not at the beginning of the caption, do nothing
  if (!isEqual(editor.selection.anchor.path, Editor.start(editor, path).path)) return;

  event.preventDefault();
  event.stopPropagation();

  Transforms.select(editor, Path.previous(path));
};

export default [backspace, arrowUp];
